//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('paymentLangs', {
//        templateUrl: 'views/components/views/paymentLangs/paymentLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'ttGridFactory', function ($stateParams, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let paymentId = $stateParams.payment_id;
            
//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_paymentlangs_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 2744,
//                    parameters: { payment_id: paymentId }
//                });
            
//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
